import { shallowEqualArrays } from 'shallow-equal';
export class MixinClassEffect {
    constructor(effectFn) {
        this.effectFn = effectFn;
    }
    destroy() {
        var _a;
        (_a = this.cleanup) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    update(...args) {
        var _a;
        if (!shallowEqualArrays(this.oldArgs, args)) {
            (_a = this.cleanup) === null || _a === void 0 ? void 0 : _a.call(this);
            this.oldArgs = args;
            this.cleanup = this.effectFn(...args) || undefined;
        }
    }
}

//# sourceMappingURL=MixinClassEffect.js.map
